/*
 * Module handling landlord administration
 */

define([
  "marionette",
  "backbone",
  "underscore",
  "messaging/messenger",
  "./landlordAdminView",
  "modules/shared/sortableList/sortableListModule",
  "./landlordModal/landlordModalModule",
  "./landlordModel",
], function (
  Marionette,
  Backbone,
  _,
  Messenger,
  LandlordAdminView,
  SortableListModule,
  LandlordModalModule,
) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "landlordAdmin";
      this.region = options.region;
      this._setUpVents();
    },
    show: function () {
      this.landlords = Messenger.reqres.request("landlords");

      Messenger.onSave(function () {
        if (this.landlord) {
          this.landlord.saveModel();
        } else {
          Messenger.saveAttempted(true); //success
        }
      }, this);

      this.view = new LandlordAdminView.landlordAdminView();

      const headers = Messenger.reqres.request("landlord:list:headers");
      const extendedEvents = {
        "click .deleteLandlord": function () {
          const model = this.model;
          if (model.get("tenantCapacity")["usage"] === 0) {
            Messenger.yesNoDialog(
              "admin.landlordAdmin.confirmDelete",
              {
                yes: function () {
                  Messenger.vent.trigger("track:interaction", {
                    action: "Delete Landlord",
                    id: model.id,
                    idType: "Landlord",
                    object: "Landlord",
                  });
                  model.deleteModel();
                },
              },
              this,
            );
          }
        },
        "hover .deleteLandlord": function () {
          this.$el.find(".deleteLandlord").tooltip("show");
        },
      };
      this.landlordsList = this.addSubModule(
        new SortableListModule({
          region: this.view.landlordsList,
          headers: headers,
          recordsPerPage: SortableListModule.DEFAULT_RECORDS_PER_PAGE,
          namespace: "landlords",
          extendedEvents: extendedEvents,
        }),
      );

      this.view.on(
        "show",
        function () {
          this.landlordsList.show(this.landlords);
        },
        this,
      );

      this.view.on(
        "add:landlord",
        function () {
          const landlord = this.landlords.addNewLandlord();
          Messenger.vent.trigger(
            "show:modal",
            LandlordModalModule,
            {
              editMode: false,
            },
            landlord,
            {
              title: "admin.landlordAdmin.addLandlord",
              closeButton: false,
              closeOnBackgroundClick: false,
              modelWidth: "900px",
              trackInteraction: {
                action: "Add Landlord",
                object: "Landlord",
              },
            },
          );
        },
        this,
      );

      this.showRegion(this.view);
    },
    _setUpVents: function () {
      //Show the landlord admin screen
      Messenger.vent.on(
        "show:account:admin:landlords",
        function () {
          Backbone.history.navigate("accountAdmin/landlords");
          this.show();
        },
        this,
      );

      Messenger.vent.on(
        "landlords" + ":selected:row",
        function (model) {
          Messenger.vent.trigger("show:account:admin:landlord:profile", model);
        },
        this,
      );
    },
  });
});
